import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";

const authHeaders = (accessToken) => ({
  Authorization: `Bearer ${accessToken}`,
});

const getActiveLoginAnnouncement = async () => {
  const response = await axios.get(`${ApiHost}/system/announcement/login`);
  return response.data.Announcement || null;
};

const getLoginAnnouncementSettings = async (accessToken) => {
  const response = await axios.get(`${ApiHost}/system/admin/announcement/login`, {
    headers: authHeaders(accessToken),
  });
  return response.data.Settings;
};

const saveLoginAnnouncementSettings = async (settings, accessToken) => {
  const response = await axios.post(
    `${ApiHost}/system/admin/announcement/login`,
    settings,
    { headers: authHeaders(accessToken) }
  );
  return response.data.Settings;
};

export {
  getActiveLoginAnnouncement,
  getLoginAnnouncementSettings,
  saveLoginAnnouncementSettings,
};
